export const clearSession = () => {
  window.localStorage.setItem('ch_isLogin', "0")
  window.localStorage.setItem('ch_token', "")
  window.localStorage.setItem('ch_uname', "")
  window.localStorage.setItem('ch_uid', "")
  window.localStorage.setItem('ch_parentid', "0")
  window.localStorage.setItem('ch_uimage', "")
  window.localStorage.setItem('ch_urole', "")
  window.localStorage.setItem('ch_is_admin', "")

  window.location.href = window.localStorage.ch_domain;
};


export const ip="18.223.119.58";
//export const ip="localhost:8080"

export const getRealImageSrc = (image_src) => {
  let domain_url = window.location.origin.toString();


  if(image_src===undefined||image_src===null)
  {
    return "";
  }
  if (!image_src.startsWith(domain_url)&&!image_src.startsWith("udata/")) {
    return image_src;
  }
  let time = (new Date()).getTime()
  if (domain_url.includes("localhost")) {
    domain_url = "http://"+ip;
  }
  let src = image_src.startsWith("data") ? image_src : (domain_url + "/" + image_src + "?time=" + time);
  return src;

};

export const setSearchValue = (value) => {
  return {type:"SET_SEARCH_VALUE", searchValue:value}
};


export const updateCreateFolderFile = (value) => {
  return {type:"Update_Create_Folder_File", updateCreateFolderFile:value}
};

export const setCurrentUosPid = (value) => {
  return {type:"Set_Current_Uos_Pid", current_uos_pid:value}
};